import ConceptPage from './ConceptPage';

export default ConceptPage;